import { Alert, useTenant } from "@dehub/theme";
import { LockSimpleIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

/** Calm info note (theme Alert, kind info): the locked fields are not an error. */
export function PartnerAlert() {
  const { t } = useTranslation("partner");
  const tenant = useTenant();

  return (
    <Alert color="gray" icon={<LockSimpleIcon size={18} aria-hidden="true" />} role="note">
      {t("lockNotice", { tenant: tenant?.name || "DeHUB" })}
    </Alert>
  );
}
